import React, { useState } from "react";
import { examDuration } from "../constant/Constants";

const StudentAccordionPage = () => {
  const [active, setActive] = useState(1);
  const handleActive = (index) => {
    setActive((prev) => (prev === index ? 0 : index));
  };

  const faqDataFull = [
    {
      id: "One",
      ariaExpanded: "true",
      title: "How does Practido help in Olympiad exam preparation?",
      content: `Practido makes Olympiad prep way easier and far more enjoyable. As an e learning online platform, it provides practice tests and topic-wise quizzes, offering one-to-one live buddy challenge and open challenge feature to students. This helps in engaging in healthy competition with friends, by earning points, coins, and trophies, this encouraging further participation.`,
    },
    {
      id: "Two",
      ariaExpanded: "false",
      title: "Which classes and subjects does Practido cover?",
      content:
        "Practido covers the core subjects students need for strong academic growth: Maths, Science, English, and Computer. It supports multiple classes from 1 to 8, making it one of the most flexible <u>online learning platforms for students</u>. Whether you’re in primary, middle school, or preparing for advanced Olympiads, you’ll find structured practice tailored to your level.",
    },
    {
      id: "Three",
      ariaExpanded: "false",
      title: "How can I practice math online for free?",
      content:
        "With Practido, practicing Math online for free is incredibly simple. Start your practice test instantly with the initial free features. The comprehensive setup of the Practido Olympiad Practice App further offers the option for students to choose a paid subscription too.",
    },
    {
      id: "Four",
      ariaExpanded: "false",
      title: "How does the Olympiad exam work?",
      content:
        "Olympiad exams are competitive tests designed to evaluate a student’s understanding of concepts beyond regular school-level learning. With <a className='link' href='https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice' target='_blank'>Practido - Olympiad Practice Android App</a> and <a className='link' href='https://apps.apple.com/us/app/practido-olympiad-practice/id6746647468' target='_blank'>Practido - Olympiad Practice iOS App</a>, students can prepare exactly how the actual Olympiad exam works cross platform seamlessly. ",
    },
    {
      id: "Five",
      ariaExpanded: "false",
      title: "What is an Olympiad exam?",
      content:
        "An Olympiad exam is a national or international-level competition that challenges students in subjects like Maths, Science, English, and Computer. The goal is to identify young talent and encourage deeper understanding of concepts.",
    },
    {
      id: "Six",
      ariaExpanded: "false",
      title: "Which Olympiad is best?",
      content:
        "The best Olympiad depends on the student’s goals and interests. For Maths enthusiasts, the <u>International Mathematical Olympiad</u> (IMO) is the most prestigious. For broader skill development, Olympiads like NSO (Science), NCO (Computer), and IEO (English) are excellent choices. Practido supports students preparing for all major Olympiads through powerful tools like topic-based quizzes and exam-style <u>online exam test</u> simulations on the Practido Olympiad Practice app.",
    }
    
  ];
  return (
    <div className="accordion" id="accordiondata">
      {faqDataFull?.map(({ id, ariaExpanded, title, content }, index) => (
        <div
          className={`card ${active === index + 1 ? "active" : ""}`}
          key={id}
        >
          <div className="card-header" id={`heading${id}`}>
            <button
              className={`btn-link btn-block text-left ${
                ariaExpanded !== "true" ? "collapsed" : ""
              }`}
              type="button"
              data-toggle="collapse"
              data-target={`#collapse${id}`}
              aria-expanded={ariaExpanded}
              aria-controls={`collapse${id}`}
              onClick={() => handleActive(index + 1)}
            >
              {title}
            </button>
          </div>
          <div
            id={`collapse${id}`}
            className={`collapse ${ariaExpanded === "true" ? "show" : ""}`}
            aria-labelledby={`heading${id}`}
            data-parent="#accordiondata"
          >
            <div
              className="card-body"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StudentAccordionPage;
